import get from 'lodash/get';

export default (object, path) => {
  const result = get(object, path, '-');
  if (!result || result.length === 0) {
    return '-';
  }
  return result;
};
